import React, { ChangeEvent, useState } from 'react'
import { WebsiteBannerFile } from '../../list/types'
import { Upload, UploadProps, UploadFile, Flex, Card } from 'antd'
import { CButton, CFormCheck, CFormInput } from '@coreui/react-pro'
import { PlusOutlined } from '@ant-design/icons'
import {
  submitCreateSocialMediaFile,
  submitUpdateSocialMediaFile,
} from './model'
import { FileManagerFormItem } from './types'
import { env } from '../../../../../../libs/constants'

type Props = {
  data: WebsiteBannerFile
  mode: 'create' | 'edit'
}

const uploadButton = (
  <button
    style={{
      border: 0,
      background: 'none',
    }}
    type="button"
  >
    <PlusOutlined />
    <div
      style={{
        marginTop: 8,
      }}
    >
      Upload
    </div>
  </button>
)

const FILE_HOST = 'static.hw.online'

export const FileManagerForm: React.FC<Props> = ({ data, mode }) => {
  const [fileManagerForm, setFileManagerForm] =
    useState<FileManagerFormItem>(data)

  const [fileList, setFileList] = useState<UploadFile[]>(
    data.originPath
      ? [
          {
            url: `https://${FILE_HOST}/public${data.originPath}`,
            uid: '1',
            name: data.fName,
          },
        ]
      : [],
  )

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
    setFileList(newFileList)
    if (newFileList[0]) {
      setFileManagerForm((prev) => ({
        ...prev,
        fName: newFileList[0].name,
        fSize: newFileList[0].size || 0,
      }))
    }
  }

  const handleChangeForm = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value
    const targetName = event.currentTarget.name

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setFileManagerForm({
      ...fileManagerForm,
      [targetName]: value,
    })
  }

  return (
    <Card size="small" style={{ width: 200 }}>
      <Flex vertical gap={5}>
        <Upload
          listType="picture-card"
          fileList={fileList}
          maxCount={1}
          accept="image/gif, image/jpeg, image/jpg, image/png"
          onPreview={() => console.log()}
          onChange={handleChange}
          onRemove={() => {
            setFileList([])
            setFileManagerForm((prevState) => ({
              ...prevState,
              previewPath: '',
              originPath: '',
              fDimensions: '',
              fSize: 0,
              fExtension: '',
              format: '',
              fName: '',
            }))
          }}
          beforeUpload={(file) => {
            const scr = URL.createObjectURL(file)

            if (file.type.includes('image')) {
              const img = new Image()

              img.onload = () => {
                setFileManagerForm((prev) => ({
                  ...prev,
                  fDimensions: `${img.width}x${img.height}`,
                  fExtension: file.name.split('.').reverse()[0],
                }))
              }
              img.src = scr
            }
          }}
        >
          {fileList.length >= 1 ? null : uploadButton}
        </Upload>
        <Flex vertical gap={5}>
          <div>
            <CFormInput
              type="text"
              name="fName"
              value={fileManagerForm.fName}
              onChange={handleChangeForm}
              label="File name"
              minLength={3}
              maxLength={30}
              required
            />
          </div>
          <div>
            {fileManagerForm.fSize
              ? `Size: ${fileManagerForm.fSize} bites`
              : ``}
          </div>
          <div>{fileManagerForm.fDimensions || ''}</div>
        </Flex>
        <CFormCheck
          name="isVisible"
          label="Active"
          checked={fileManagerForm.isVisible}
          onChange={handleChangeForm}
        />
        <CButton
          size="sm"
          onClick={() => {
            if (mode === 'create' && fileList[0]) {
              submitCreateSocialMediaFile({
                ...fileManagerForm,
                file: fileList[0].originFileObj || '',
              })
            }
            if (mode === 'edit') {
              submitUpdateSocialMediaFile({
                ...fileManagerForm,
                file: fileList[0]?.originFileObj || '',
              })
            }
          }}
        >
          Save
        </CButton>
      </Flex>
    </Card>
  )
}
